import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import {PATH_DASHBOARD, PATH_ONBOARDING} from '../routes/paths';
import {useSelector} from "../redux/store";
import {createCheckoutSession} from "../utils/checkout";

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default function GuestGuard({children}) {
    const {isAuthenticated, onboarding, workspace} = useAuth();
    const {checkout} = useSelector((state) => state.product);

    if (isAuthenticated) {
        if (!onboarding || !onboarding.isCompleted) {
            return <Navigate to={PATH_ONBOARDING.root}/>;
        }

        const {cart} = checkout;
        if (checkout && cart.length > 0) {
            const priceId = cart[0].id;
            if (!workspace?.id) return null;
            createCheckoutSession(workspace.id, priceId).then((sessionUrl) => {
                const url = sessionUrl?.url || sessionUrl;
                if (url) window.location.href = url;
            });
            return null;
        } else {
            return <Navigate to={PATH_DASHBOARD.root}/>;
        }
    }

    return <>{children}</>;
}
